import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { useCreateJobTitle } from "../hooks";
import { JobTitleForm } from "../components";

export const CreateJobTitle: React.FC = () => {
  const navigate = useNavigate();
  const { form, submit, loading } = useCreateJobTitle({
    defaultValues: {},
    onCompleted: () => {
      toast.success("L'intitulé de poste a été créé avec succès");
      navigate("/job-titles");
    },
  });

  return (
    <>
      <Header
        title="Intitulé de poste"
        subtitle="Créer un nouvel intitulé de poste"
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/job-titles`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Nouvel intitulé de poste" />
          <JobTitleForm loading={loading} submit={submit} form={form} />
        </div>
      </div>
    </>
  );
};
